import { makeStyles } from '@material-ui/core';
import chevronRight from './../assets/icons/chevronRight.svg';
import { Link } from 'react-router-dom';
import { useSetMobilePageTitle } from 'contexts/MobilePageTitleContext';

const useStyles = makeStyles((theme) => ({
  pageTitle: {
    width: '100%',
    margin: '70px auto 25px',
    fontFamily: 'Roboto',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  pageTitle__text: {
    fontSize: 26,
    fontWeight: 600,
  },
  breadcrumbs: {
    display: 'flex',
    alignItems: 'center',
  },
  breadcrumbs__text: {
    color: '#828282',
    cursor: 'pointer',
    '&:hover': {
      color: '#828282',
    },
  },
  breadcrumbs__chevron: {
    margin: '0 8px',
    filter: 'invert(50%) sepia(1%) saturate(0%) hue-rotate(152deg) brightness(101%) contrast(96%)',
    width: 7,
  },
  breadcrumbs__active: {
    color: '#4CA2CD',
    fontWeight: 500,
  },
}));

interface PageTitleProps {
  title: string;
  mobileTitle?: string;
  breadcrumbs?: string[];
  link?: string;
}

const PageTitle = ({ title, mobileTitle, breadcrumbs = [], link }: PageTitleProps) => {
  const classes = useStyles();

  useSetMobilePageTitle(mobileTitle ?? title);

  return (
    <div className={classes.pageTitle}>
      <h1 className={classes.pageTitle__text}>{title}</h1>
      <div className={classes.breadcrumbs}>
        {breadcrumbs.map((crumb, index) => (
          <span key={crumb + '-' + index}>
            {breadcrumbs.length - 1 === index ? (
              <span className={classes.breadcrumbs__active}>{crumb}</span>
            ) : (
              <>
                <Link
                  to={`/${link}`}
                  style={{ textDecoration: 'none' }}
                  className={classes.breadcrumbs__text}
                >
                  <span>{crumb}</span>
                </Link>
                <img alt={'>'} className={classes.breadcrumbs__chevron} src={chevronRight} />
              </>
            )}
          </span>
        ))}
      </div>
    </div>
  );
};

export default PageTitle;
